// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaMessageFile__file-ef4bfd {
  display: flex;
  justify-content: stretch;
  align-items: center;
  background: var(--base-15);
  border-radius: 16px;
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-110);
  padding: 12px 16px;
  width: 100%;
  box-sizing: border-box;
  position: relative;
}

.MediaMessageFile__content-d3b716 {
  flex: 1;
  flex-direction: column;
  overflow: hidden;
  margin-inline-end: 8px;
  margin-inline-start: 8px;
}

.MediaMessageFile__delete-panel-a1b307 {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 66px;
  padding-inline-start: 33px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.25s ease-in-out;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, var(--base-15) 33%, var(--base-15) 100%);
  border-radius: 0 16px 16px 0;
}

.MediaMessageFile__file-ef4bfd:hover .MediaMessageFile__delete-panel-a1b307 {
  opacity: 1;
}

.MediaMessageFile__delete-a17bd4 {
  flex: 0 0 auto;
}

.MediaMessageFile__delete-a17bd4 svg {
  fill: currentColor;
}

.MediaMessageFile__size-f21932 {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/MediaMessagePopup/ItemMedia/MediaMessageFile/MediaMessageFile.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,wBAAA;EACA,mBAAA;EACA,0BAAA;EACA,mBAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,OAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,wBAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,qCAAA;EACA,sGAAA;EAMA,4BAAA;AAJF;;AAOA;EACE,UAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,kBAAA;AAJF;;AAOA;EACE,4BAAA;EACA,8CAAA;EACA,qBAAA;AAJF","sourcesContent":[".file {\n  display: flex;\n  justify-content: stretch;\n  align-items: center;\n  background: var(--base-15);\n  border-radius: 16px;\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-110);\n  padding: 12px 16px;\n  width: 100%;\n  box-sizing: border-box;\n  position: relative;\n}\n\n.content {\n  flex: 1;\n  flex-direction: column;\n  overflow: hidden;\n  margin-inline-end: 8px;\n  margin-inline-start: 8px;\n}\n\n.delete-panel {\n  position: absolute;\n  right: 0;\n  top: 0;\n  height: 100%;\n  width: 66px;\n  padding-inline-start: 33px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.25s ease-in-out;\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0) 0%,\n    var(--base-15) 33%,\n    var(--base-15) 100%\n  );\n  border-radius: 0 16px 16px 0;\n}\n\n.file:hover .delete-panel {\n  opacity: 1;\n}\n\n.delete {\n  flex: 0 0 auto;\n}\n\n.delete svg {\n  fill: currentColor;\n}\n\n.size {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"file": `MediaMessageFile__file-ef4bfd`,
	"content": `MediaMessageFile__content-d3b716`,
	"delete-panel": `MediaMessageFile__delete-panel-a1b307`,
	"deletePanel": `MediaMessageFile__delete-panel-a1b307`,
	"delete": `MediaMessageFile__delete-a17bd4`,
	"size": `MediaMessageFile__size-f21932`
};
module.exports = ___CSS_LOADER_EXPORT___;
